import { Alert, Box, Tooltip, Typography } from '@mui/material'
import DataGrid from '../../../../table/DataGrid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'

const IsValidComponent = ({ isValid, index, error }) => {
  return isValid ? (
    <Typography style={{ color: 'green' }}>
      <FontAwesomeIcon icon='check' color='currentColor' />
    </Typography>
  ) : (
    <Tooltip
      arrow
      id={`tooltip-error-${index}`}
      placement='top'
      title={
        error ? (
          <div>
            {Object.keys(error).map((key) => (
              <div key={`error-${index}-${key}`}>
                <b>{key}</b>: {error[key]}
              </div>
            ))}
          </div>
        ) : (
          'Invalid row'
        )
      }
    >
      <Typography style={{ color: 'red' }} className='cursor-pointer'>
        <FontAwesomeIcon icon='xmark' color='currentColor' />
      </Typography>
    </Tooltip>
  )
}

const ContentFile = ({ contentFile = [], columnsHeaders = [], loading }) => {
  const [filter, setFilter] = useState('')
  const validRows = contentFile.filter((row) => row.isValid)?.length || 0
  const invalidRows = contentFile.filter((row) => !row.isValid)?.length || 0

  const columns = columnsHeaders.map((col) => ({
    key: col,
    label: col?.split('_')[1],
    show: true
  }))
  columns.unshift({
    key: 'isValid',
    label: '',
    show: true
  })
  columns.unshift({ key: 'index', label: '', show: true })

  const rows = contentFile
    ?.filter((row) => {
      if (filter === 'valid') return row.isValid
      if (filter === 'invalid') return !row.isValid
      return true
    })
    ?.map((row, index) => {
      const newRows = {}
      Object.keys(row).forEach((key) => {
        newRows[key] =
          row[key].length > 30 ? (
            <Tooltip arrow id={`tooltip-${index}-${key}`} placement='top' title={row[key]}>
              <span className='text-sm cursor-pointer text-nowrap'>{row[key].substring(0, 30) + '...'}</span>
            </Tooltip>
          ) : (
            <span className='text-sm text-nowrap'>{row[key]}</span>
          )
      })
      return {
        ...newRows,
        isValid: <IsValidComponent index={index} isValid={row.isValid} error={row.error} />
      }
    })

  return (
    <Box className='flex flex-col gap-2'>
      <div className='grid grid-cols-3 gap-2 '>
        <Alert
          severity='info'
          icon={false}
          className='border border-current cursor-pointer'
          onClick={() => setFilter('')}
        >
          <Typography variant='h4' className='font-bold'>
            {contentFile.length}
          </Typography>
          <Typography variant='body2'>Total rows</Typography>
        </Alert>
        <Alert
          severity='success'
          icon={false}
          className='border border-current cursor-pointer'
          onClick={() => setFilter('valid')}
        >
          <Typography variant='h4' className='font-bold'>
            {validRows}
          </Typography>
          <Typography variant='body2'>Valid rows</Typography>
        </Alert>
        <Alert
          severity='error'
          icon={false}
          className='border border-current cursor-pointer'
          onClick={() => setFilter('invalid')}
        >
          <Typography variant='h4' className='font-bold'>
            {invalidRows}
          </Typography>
          <Typography variant='body2'>Invalid rows</Typography>
        </Alert>
      </div>
      <Box className='relative h-screen-1/3'>
        <DataGrid
          loading={loading}
          rows={rows}
          columns={columns}
          showSetting={false}
          rowsPerPage={rows?.length || 10}
        />
      </Box>
    </Box>
  )
}

export default ContentFile
